import * as React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

import { accountsSelectors } from 'companion-app-components/flux/accounts';
import { getCurrentAccountGroupName } from 'companion-app-components/flux/account-groups/accountGroupsSelectors';

import { getIsCurrentDatasetOwner } from 'data/datasetSharing/selectors';
import emptyBox from 'assets/zero-state-images/empty-account-group.svg';
import { styles } from './styles';

const useStyles = makeStyles()(styles as Record<string, any>);

const EmptyEntityPage: React.FC = () => {
  const navigate = useNavigate();
  const { classes } = useStyles();
  const isCurrentDatasetOwner = useSelector(getIsCurrentDatasetOwner);
  const accountsLoadPending = useSelector(accountsSelectors.getLoadPending);
  const accountsById = useSelector(accountsSelectors.getAccountsById);
  const selectedAccountGroupName = useSelector(getCurrentAccountGroupName);

  if (!accountsLoadPending && accountsById?.size >= 1) {
    navigate('/', { replace: true });
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.content}>
        <img className={classes.image} src={emptyBox} alt="No accounts assigned" />
        <Typography variant="h5" className={classes.title}>
          {isCurrentDatasetOwner ? 'No accounts assigned' : 'No accounts shared'}
        </Typography>
        {isCurrentDatasetOwner ? (
          <>
            <Typography variant="body1" className={classes.body}>
              You haven&apos;t assigned any accounts to your{' '}
              <span className={classes.entityName}>{selectedAccountGroupName || ''}</span> entity.
            </Typography>
            <Typography variant="body1" className={classes.body}>
              To assign accounts, open Quicken on your desktop and go to: <br />
              <Box component="span" fontWeight={500}>Tools &gt; Entity Management...</Box>
            </Typography>
          </>
        ) : (
          <Typography variant="body1" className={classes.body}>
            The owner hasn&apos;t shared any accounts yet.
          </Typography>
        )}

      </Box>
    </Box>
  );
};

export default EmptyEntityPage;
